import {
  PrismicGraphqlService,
  SuraLoadingService,
  ObjectByTenantService,
  SetGoogleTagManagerService,
  TenantService,
  SuraBreadcrumbService,
} from '@segurosvoluntarios_vel/commons-services';
import { config } from 'src/app/shared/prismic/config';
import { Component, OnDestroy } from '@angular/core';
import { filter, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { PagoFacade } from 'src/app/pago/services/pago-facade/pago.facade';
import { saveTenant } from 'src/app/store/actions/pago.action';
import { PasosBreadcrumb } from 'src/app/pago/const/PasosBreadcrumb.const';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnDestroy {
  tenant: string;
  showChatBot: boolean = false;
  urlIconChatBot: string = environment.webchatTibotLogo;
  subscription: Subscription = new Subscription();
  pasos = PasosBreadcrumb;
  pasoActual: number;
  mostrarPasos = true;

  constructor(
    public suraLoadingService: SuraLoadingService,
    private prismicGraphqlService: PrismicGraphqlService,
    private tenantService: TenantService,
    private setGoogleTagManagerService: SetGoogleTagManagerService,
    private objectByTenantService: ObjectByTenantService,
    private pagoFacade: PagoFacade,
    private suraBreadcrumbService: SuraBreadcrumbService
  ) {
    this.prismicGraphqlService.setConfigPrismic(config);
    this.tenantService
      .getTenant()
      .pipe(
        filter((tenant: string) => !!tenant),
        take(1)
      )
      .subscribe((tenant: string) => {
        this.pagoFacade.dispatch(saveTenant({ tenant }));
        this.injectGoogleTagManager(tenant);
        this.tenant = tenant;
        this.showChatBot = true;
      });
    this.subscription.add(this.subscribeToGetStep());
    this.suraBreadcrumbService.setStep(3);
  }

  subscribeToGetStep(): Subscription {
    return this.suraBreadcrumbService
      .getStep()
      .subscribe((step: number) => (this.pasoActual = step));
  }

  injectGoogleTagManager(tenant: string) {
    const dataOfGoogleTagManager = this.objectByTenantService.getObjectByTenant(
      environment,
      tenant
    ).googleTagManager;
    this.setGoogleTagManagerService.setGoogleTagManager(
      dataOfGoogleTagManager.GTM,
      dataOfGoogleTagManager
    );
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
